import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { Unit } from 'src/features/units/utils/types';
import { unitsMessages } from 'src/features/units/utils/messages';
import UpdateUnitFormModal from 'src/features/units/components/forms/UpdateUnitFormModal';
import DeleteUnitFormModal from 'src/features/units/components/forms/DeleteUnitFormModal';

export default function CellUnitActions({ row }: CellContext<Unit, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateUnitFormModal
                        semantics={{ entryName: formatMessage(unitsMessages.unit).toLowerCase() }}
                        selectedUnit={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateUnitFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteUnitFormModal selectedUnit={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteUnitFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
